import { Guid } from 'guid-typescript';
import { actions as _act } from '@/models/store.actions';

let depositSignUserSessions: { [key: string]: IDepositSignUserSession } = {};

export interface IDepositSignUserSession {
  depositSignUserSessionId: string;
  clientId: string;
  login: string;
  password: string;
  keys: Array<any>;
  selectedKeyId: string;
  selectedKeyPassword: string;
  endUserOwnerInfo: null;
  ownCertificates: null;
}

class DepositSignUserSessionService {
  public createSessionId(): string {
    return Guid.raw();
  }

  public getUserSession(key: string): IDepositSignUserSession {
    return JSON.parse(JSON.stringify(depositSignUserSessions[key] || null)) as IDepositSignUserSession;
  }

  public saveUserSession(key: string, s: IDepositSignUserSession): void {
    if (s) {
      depositSignUserSessions[key] = JSON.parse(JSON.stringify(s)) as IDepositSignUserSession;
    } else {
      throw new Error('User session object is not defined');
    }
  }

  public deleteUserSession(key: string): void {
    delete depositSignUserSessions[key];
  }
}

const depositSignUserSessionService = new DepositSignUserSessionService();

export { depositSignUserSessionService };
